// export const BaseUrl = "http://18.209.67.91:6060";
// Mohit AWS Url
// export const BaseUrl = "http://13.60.63.167:6060";
// Ajay AWS Url
// export const BaseUrl = "https://avijobackendtest-production.up.railway.app";
// Render Url
// export const BaseUrl = "https://avijo-1.onrender.com";
export const BaseUrl = "https://kxmwv7zzhj.ap-south-1.awsapprunner.com" 
//"https://d54ryxu5pa.ap-south-1.awsapprunner.com";
